import { Directive, Input, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { NFormComponent } from '@pebula/nform';

@Directive({
  selector: '[disableForm]',
  standalone: false,
})
export class DisableFormDirective implements OnChanges, OnDestroy {
  @Input('disableForm') disabled: boolean;
  @Input() nFormCmp: NFormComponent;

  private debounceTimeout: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled && this.nFormCmp?.nForm && this.nFormCmp.form) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        // Coerce null/undefined to false to prevent errors
        const shouldDisable = !!this.disabled;
        this.nFormCmp.form[shouldDisable ? 'disable' : 'enable']({ emitEvent: false });
        this.cdr.detectChanges();
      }, 500);
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.debounceTimeout);
  }
}
